<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <home-page />
      <div
        v-if="userData.active"
        class="view-all-div"
      >
        <!-- <home-page-active-check-in /> -->
        <home-page-pending-request />
        <br>
        <br>
      </div>
    </div>
    <alert-dialog
      v-if="showTimezoneDialog"
      :title="'Timezone'"
      :message="'Your timezone has changed. Update now?'"
      @closed="showTimezoneDialog = false"
      @confirmed="changeTimezone"
    />
    <alert-dialog
      v-if="showTimesheetPopup"
      title="Missed Check-in Alert"
      :message="'Your previous timesheet is missing.'"
      cancel-button="Later"
      confirm-button="Go to timesheet"
      @confirmed="toTimesheets"
      @closed="closeTimesheetPopup"
    />
    <alert-dialog
      v-if="showPwaClosingPopup"
      title="Swift Check-In App"
      :message="`The SwiftCheckIn Web app will be discontinued on 22 May 2026. Please download the mobile app to continue using Swift Check-In without interruption.`"
      confirm-button="Download App"
      cancel-button="Later"
      :download-pop-up="true"
      @confirmed="downloadApp"
      @closed="closePwaPopup"
    />
  </div>
</template>

<script>
import { getTimeZone } from '../../../utils/timezone';
import HomePage from '../Components/HomePage.vue';
import HomePagePendingRequest from '../Components/HomePagePendingRequest.vue';
import AlertDialog from '../../components/AlertDialog.vue';

export default {
  name: 'Home',
  components: {
    HomePage,
    HomePagePendingRequest,
    AlertDialog,
  },

  data () {
    return {
      permissionStatus: Notification.permission,
      isPWA: false,
      showTimezoneDialog: false,
      showTimesheetPopup: false,
      showPwaClosingPopup: false,
    };
  },

  computed: {
    user () {
      return this.$store.getters.getUser;
    },
    shouldShowPwaPopup () {
      const today = new Date().toISOString().slice(0, 10);
      const lastShown = localStorage.getItem('pwa_closing_popup_last_shown');

      return lastShown !== today;
    },
    userDetails () {
      return this.$store.getters['userprofile/getUserDetails'];
    },
    userData () {
      return this.$store.getters.getSelectedOrganization;
    },
    timesheetAlert () {
      return this.$store.getters['alert/getTimesheetAlert'];
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    orgSettings () {
      return this.$store.getters['organization/getOrganizationSettings'];
    },
    isMissedTimesheetPopUpEnabled () {
      return this.orgSettings.missed_previous_day_alert;
    },
    shouldShowTimesheetPopup () {
      if (this.timesheetAlert) return false;
      const today = new Date().toISOString().slice(0, 10);
      const lastShown = localStorage.getItem('timesheet_alert_last_shown');
      return lastShown !== today;
    },
  },

  async mounted () {
    this.checkPwaClosingPopup();
    this.isPWA = this.isPWAInstalled();
    await this.fetchOrgDetails();
    this.$store.dispatch('appusers/updateAppUserPlatform', {
      platform_type: this.isPWA ? 'app' : 'web',
    });
    await this.$store.dispatch('userprofile/fetchUserDetails');
    await this.checkTimezone();
  },

  methods: {
    isPWAInstalled () {
      return (
        window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone === true
      );
    },
    async fetchOrgDetails () {
      await this.$store.dispatch(
        'organization/fetchOrganizationSettings',
        this.selectedOrganization,
      );
      if (!this.userData.timesheet_tracking) return;
      if (!this.isMissedTimesheetPopUpEnabled) return;

      if (
        this.shouldFetchTimesheetAlert() &&
        this.selectedOrganization.active
      ) {
        await this.checkTimesheetAlert();

        if (this.shouldShowTimesheetPopup) {
          this.showTimesheetPopup = true;
        }
      }
    },
    checkPwaClosingPopup () {
      const closeDate = new Date('2026-05-22');
      const today = new Date();

      // show only before closing date
      if (today <= closeDate && this.shouldShowPwaPopup) {
        this.showPwaClosingPopup = true;
      }
    },

    closePwaPopup () {
      const today = new Date().toISOString().slice(0, 10);

      localStorage.setItem('pwa_closing_popup_last_shown', today);

      this.showPwaClosingPopup = false;
    },

    downloadApp () {
      const today = new Date().toISOString().slice(0, 10);

      localStorage.setItem('pwa_closing_popup_last_shown', today);

      this.showPwaClosingPopup = false;

      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const isAndroid = /Android/.test(navigator.userAgent);

      if (isIOS) {
        window.open(
          'https://apps.apple.com/us/app/swift-checkin-construction-app/id6755225256',
          '_blank',
        );
      } else if (isAndroid) {
        window.open(
          'https://play.google.com/store/apps/details?id=com.swiftcheckin.app',
          '_blank',
        );
      } else {
        // fallback
        window.open(
          'https://play.google.com/store/apps/details?id=com.swiftcheckin.app',
          '_blank',
        );
      }
    },
    shouldFetchTimesheetAlert () {
      const today = new Date().toISOString().slice(0, 10);
      const lastShown = localStorage.getItem('timesheet_alert_last_shown');
      return lastShown !== today;
    },
    closeTimesheetPopup () {
      const today = new Date().toISOString().slice(0, 10);
      localStorage.setItem('timesheet_alert_last_shown', today);
      this.showTimesheetPopup = false;
    },
    toTimesheets () {
      const today = new Date().toISOString().slice(0, 10);
      localStorage.setItem('timesheet_alert_last_shown', today);
      this.$router.push('/timesheets');
    },

    async checkTimezone () {
      const timezone = getTimeZone();

      if (this.userDetails.timezone === null) {
        await this.$store.dispatch('userprofile/updateTimezone', {
          params: { timezone },
        });
      } else if (this.userDetails.timezone !== timezone) {
        this.showTimezoneDialog = true;
      } else {
        this.showTimezoneDialog = false;
      }
    },
    async changeTimezone () {
      const timezone = getTimeZone();
      await this.$store
        .dispatch('userprofile/updateTimezone', {
          params: {
            timezone: timezone,
          },
        })
        .then(() => {
          window.location.reload();
          // this.$router.push({ name: 'Logout' });
        });
    },
    async requestPermission () {
      if ('Notification' in window) {
        const permission = await Notification.requestPermission();
        this.permissionStatus = permission;
      } else {
        alert('Notifications are not supported in this browser.');
      }
    },
    showNotification () {
      if (this.permissionStatus === 'granted') {
        navigator.serviceWorker.getRegistration().then((reg) => {
          if (reg) {
            reg.showNotification('✅ Notification Test', {
              body: 'This is a working test notification!',
              icon: '',
            });
          } else {
            alert('❌ Service worker not registered.');
          }
        });
      } else {
        alert('🔒 Notification permission not granted.');
      }
    },
    async checkTimesheetAlert () {
      await this.$store.dispatch('alert/showTimesheetAlert', {
        externalId: this.selectedOrganization.organization.external_id,
      });
    },
  },
};
</script>
<style scoped>
.content-section {
  padding-top: 80px;
}
</style>
